import React, { memo } from "react";
import styled from "styled-components";
import { defaultColor } from "../../../helpers/color";
import { transparentizedDefaultColor } from "../../../helpers/transparentize";
import Panel from "../../Layout/Panel";
import { useContent } from "./state/content";
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-pr56di-0"
})(["position:fixed;z-index:10;top:0;left:0;width:100%;height:100%;background-color:", ";"], transparentizedDefaultColor);
const Content = /*#__PURE__*/styled(Panel).withConfig({
  displayName: "Content",
  componentId: "sc-pr56di-1"
})(["position:absolute;top:50%;left:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:400px;min-height:150px;padding:7.3vh;transform:translate(-50%,-50%);box-shadow:0 0 300px ", ";"], defaultColor);
const Modal = /*#__PURE__*/memo(() => {
  const content = useContent();
  if (!content) return false;
  return /*#__PURE__*/React.createElement(Root, null, /*#__PURE__*/React.createElement(Content, null, content));
});
Modal.displayName = "Modal";
export default Modal;
//# sourceMappingURL=Modal.js.map